import { landingContent } from "../../i18n/landingContent";

export const getBenefitsData = (language) => landingContent[language].benefits;
